import { Messages } from "primereact/messages";
import React, { useEffect, useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useVesselInspectionData } from "../../queries/particularsQueries";
import { useParams } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { canShowDataSharingOptIn } from "../../utils/dataSharingHelpers";
import { useAppSelector } from "../../redux/hooks";
import { inspectionsDataSharingStatusSelector } from "../../features/inspectionsSlice";

export const DataSharingBlockedMessage = () => {
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const { inspectionId } = useParams();
    const dataSharingBlockedRef: any = useRef(null);
    const { t } = useTranslation("locale");
    const dataSharingStatus = useAppSelector(
        inspectionsDataSharingStatusSelector
    );

    const message = (
        <Trans
            i18nKey="report.dataSharingBlockedMessage"
            t={t}
            components={[<strong key="bold" />]}
        />
    );

    const { data, isLoading } = useVesselInspectionData(
        inspectionId ?? "",
        user
    );

    useEffect(() => {
        if (!isLoading && data) {
            const shouldShowBlockedMessage = canShowDataSharingOptIn(
                dataSharingStatus,
                data.dataSharingAvailable,
                data.InspectionTypeShortName
            );

            if (dataSharingBlockedRef.current) {
                dataSharingBlockedRef.current.clear();

                if (shouldShowBlockedMessage) {
                    dataSharingBlockedRef.current.show({
                        sticky: true,
                        severity: "warn",
                        summary: "",
                        detail: message,
                        closable: false
                    });
                }
            }
        }
    }, [isLoading, data, dataSharingStatus, message]);

    const shouldShowBlockedMessage = canShowDataSharingOptIn(
        dataSharingStatus,
        data?.dataSharingAvailable,
        data?.InspectionTypeShortName
    );

    if (isLoading || !shouldShowBlockedMessage) {
        return <></>;
    }

    return (
        <div className="mt-6">
            <Messages ref={dataSharingBlockedRef} />
        </div>
    );
};
